var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 33.5405L22.826 33.5105L42.09 14.4305C42.846 13.6745 43.262 12.6705 43.262 11.6025C43.262 10.5345 42.846 9.53045 42.09 8.77445L38.918 5.60245C37.406 4.09045 34.768 4.09845 33.268 5.59645L14 24.6805V33.5405ZM36.09 8.43045L39.268 11.5965L36.074 14.7605L32.902 11.5905L36.09 8.43045ZM18 26.3485L30.06 14.4025L33.232 17.5745L21.174 29.5165L18 29.5265V26.3485Z",
    fill: "#292829"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 41.5144H38C40.206 41.5144 42 39.7204 42 37.5144V20.1784L38 24.1784V37.5144H16.316C16.264 37.5144 16.21 37.5344 16.158 37.5344C16.092 37.5344 16.026 37.5164 15.958 37.5144H10V9.5144H23.694L27.694 5.5144H10C7.794 5.5144 6 7.3084 6 9.5144V37.5144C6 39.7204 7.794 41.5144 10 41.5144Z",
    fill: "#292829"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.1694263e2d0de7a3820057fac7455759.svg";
export { ForwardRef as ReactComponent };